import axios from "axios";

export default function Ticket(){
    const urlShowArticle = `${process.env.REACT_APP_PHP_APP_URL}/magasin/ticket`;

    const getTicket=()=>{
        return (axios.get(urlShowArticle));
    }
    return{
      getTicket,
    }
    }
